import { React, useState } from 'react';
import { useTranslation } from "react-i18next";
import {
    Accordion,
    Col,
    Button,
    ButtonGroup,
    InputGroup,
    Dropdown,
    Form,
    Row,
    Tab,
    Tabs,
    ListGroup,
    Table,
    Modal,
} from "react-bootstrap";

const Workflow = () => {
    const [selectedOption, setSelectedOption] = useState('');

    return (
        <main className="main overflow-hidden">
            <div className="formeditor-wrapper shadow-1 box-shadow-3">
                <div className="formeditor-header bg-white rounded-top d-flex align-items-center shadow-sm relative">
                    <Button variant="editorclose border-0 bg-transparent border">
                        <i className="bx bx-x bx-md"></i>
                    </Button>
                    <div className="headereditor-title border-start py-3 ps-3">
                        <h3>Cybersecurity Admission Form</h3>
                        <div className="headereditor-sub-title d-flex align-items-center">
                            <i className="bx bx-folder bx-xs me-1"></i> Admission Form{" "}
                        </div>
                    </div>

                    <div className="d-flex align-items-center ms-auto">
                        {/* <div className="unduredo-btns d-flex align-items-center py-3">
								<Button variant="action btn-sm px-1">
									<i className="bx bx-undo bx-sm"></i>
								</Button>
								<Button variant="action btn-sm px-1">
									<i className="bx bx-redo bx-sm"></i>
								</Button>
							</div> */}
                        <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
                            <Button variant="gray-light btn-sm">Test Run</Button>
                            <Button variant="gray-light btn-sm">Save Draft</Button>
                            <Button variant="primary btn-sm">Publish</Button>
                        </div>
                    </div>
                </div>
                <div className="d-flex rounded-bottom overflow-hidden align-items-start bg-white rounded-bottom-3 formbuilder-body">
                    <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">

                        <div className="search-div mb-3">
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="pluto-search"></i>
                                </span>
                                <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Search element"
                                />
                            </div>
                        </div>

                        <ul className='workflow-nav list-unstyled'>
                            <li className='text-sm font-medium'>
                                <a href="#" className='d-flex align-items-center gap-1 text-decoration-none'>
                                    <i className="bx bx-clipboard nav_icon"></i> Copy from Templates <i className='bx bx-chevron-right bx-sm ms-auto'></i>
                                </a>
                            </li>
                        </ul>

                        <div>
                            <span className='d-block mb-2 text-sm font-medium'>Elemments</span>
                            <ul className='element-nav-list list-unstyled d-flex flex-column row-gap-2'>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bxs-caret-right-circle text-green-600'></i> Start event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bx-calendar-event text-orange-600'></i> Action event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bx-calendar-event text-orange-600'></i> Decision event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bx-calendar-event text-orange-600'></i> Loop event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bx-calendar-event text-orange-600'></i> Wait event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bx-calendar-event text-orange-600'></i> Notification event</a>
                                </li>
                                <li className='text-sm font-medium'>
                                    <a href="" className='p-2 d-flex align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md'><i className='bx bxs-x-circle text-red-600'></i> End event</a>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start h-100">
                        <div className="p-3 rounded-2 scroll-y">
                            <div className="workflow-row d-flex flex-column align-items-center">
                                <div className="max-w-300 mx-auto border border-grey-300 rounded-lg bg-white w-100 relative">
                                    <div className='px-3 py-2 border-bottom border-grey-300 d-flex align-items-center gap-2'>
                                        <h3 className='mb-0 text-sm text-grey-800 d-flex align-items-center gap-1'><i className='bx bxs-caret-right-circle bx-sm text-green-600'></i> Start event</h3>
                                    </div>
                                    <div className='p-3'>
                                        <div className="text-base font-medium text-grey-900">User Admission form</div>
                                    </div>
                                </div>

                                <div className="max-w-300 w-100 mx-auto">
                                    <div className='d-flex flex-column align-items-center'>
                                        <div className="connector h-8 bg-grey-400"></div>
                                        <div className="circle-plus w-6 h-6 rounded-circle border border-grey-400 bg-white d-flex justify-content-center align-items-center">
                                            <i className='bx bx-plus'></i>
                                        </div>
                                        <div className="connector h-8 bg-grey-400"></div>
                                    </div>
                                    <div className='border border-grey-300 rounded-lg bg-white relative flow-selected'>
                                        <div className='px-3 py-2 border-bottom border-grey-300 d-flex align-items-cente gap-2'>
                                            <h3 className='mb-0 text-sm text-grey-800 d-flex align-items-center gap-1'><i className='bx bx-calendar-event bx-sm text-orange-600'></i> Action event</h3>
                                            <div className="ms-auto icon-row d-flex align-items-center gap-1">
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-cog'></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-copy-alt' ></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-trash' ></i>
                                                </buttom>
                                            </div>
                                        </div>

                                        <div className='p-3'>
                                            <div className="text-base font-medium text-grey-900">Faculty Review</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="max-w-300 w-100 mx-auto">
                                    <div className='d-flex flex-column align-items-center'>
                                        <div className="connector h-8 bg-grey-400"></div>
                                        <div className="circle-plus w-6 h-6 rounded-circle border border-grey-400 bg-white d-flex justify-content-center align-items-center">
                                            <i className='bx bx-plus'></i>
                                        </div>
                                        <div className="connector h-8 bg-grey-400"></div>
                                    </div>
                                    <div className='border border-grey-300 rounded-lg bg-white relative flow-selected'>
                                        <div className='px-3 py-2 border-bottom border-grey-300 d-flex align-items-cente gap-2'>
                                            <h3 className='mb-0 text-sm text-grey-800 d-flex align-items-center gap-1'><i className='bx bx-calendar-event bx-sm text-orange-600'></i> Wait event</h3>
                                            <div className="ms-auto icon-row d-flex align-items-center gap-1">
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-cog'></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-copy-alt' ></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-trash' ></i>
                                                </buttom>
                                            </div>
                                        </div>

                                        <div className='p-3'>
                                            <div className="text-base font-medium text-grey-900">Wait for 2 days</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="max-w-300 w-100 mx-auto">
                                    <div className='d-flex flex-column align-items-center'>
                                        <div className="connector h-8 bg-grey-400"></div>
                                        <div className="circle-plus w-6 h-6 rounded-circle border border-grey-400 bg-white d-flex justify-content-center align-items-center">
                                            <i className='bx bx-plus'></i>
                                        </div>
                                        <div className="connector h-8 bg-grey-400"></div>
                                    </div>
                                    <div className='border border-grey-300 rounded-lg bg-white relative flow-selected'>
                                        <div className='px-3 py-2 border-bottom border-grey-300 d-flex align-items-cente gap-2'>
                                            <h3 className='mb-0 text-sm text-grey-800 d-flex align-items-center gap-1'><i className='bx bx-calendar-event bx-sm text-orange-600'></i> Notification event</h3>
                                            <div className="ms-auto icon-row d-flex align-items-center gap-1">
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-cog'></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-copy-alt' ></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-trash' ></i>
                                                </buttom>
                                            </div>
                                        </div>

                                        <div className='p-3'>
                                            <div className="text-base font-medium text-grey-900">Wait for 2 days</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="max-w-300 w-100 mx-auto">
                                    <div className='d-flex flex-column align-items-center'>
                                        <div className="connector h-8 bg-grey-400"></div>
                                        <div className="circle-plus w-6 h-6 rounded-circle border border-grey-400 bg-white d-flex justify-content-center align-items-center">
                                            <i className='bx bx-plus'></i>
                                        </div>
                                        <div className="connector h-8 bg-grey-400"></div>
                                    </div>
                                    <div className='border border-grey-300 rounded-lg bg-white relative flow-selected'>
                                        <div className='px-3 py-2 border-bottom border-grey-300 d-flex align-items-cente gap-2'>
                                            <h3 className='mb-0 text-sm text-grey-800 d-flex align-items-center gap-1'><i className='bx bxs-x-circle bx-sm text-red-600'></i> End event</h3>
                                            <div className="ms-auto icon-row d-flex align-items-center gap-1">
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-cog'></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-copy-alt' ></i>
                                                </buttom>
                                                <buttom type="button" className="icon w-6 h-6 d-flex justify-content-center align-items-center text-primary-600">
                                                    <i className='bx bx-trash' ></i>
                                                </buttom>
                                            </div>
                                        </div>

                                        <div className='p-3'>
                                            <div className="text-base font-medium text-grey-900">Wait for 2 days</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="py-4 section-divider text-center">
                            <span className="bg-black-50 text-black">
                                <span className="pluto-page-breaker bx-xs align-middle"></span>{" "}
                                Page Breaker
                            </span>
                        </div>
                        <div className="p-3 rounded-2 bg-white border">
                            {/* <div className="section-divider text-center mb-4">
															<span className="bg-white">Add section header</span>
													</div> */}
                            <Row className="row gy-4">
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <div className="builder-row border rounded-2 bg-light">
                                        <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                                            <h4>
                                                <span className="material-symbols-outlined align-middle me-2">
                                                    notes
                                                </span>{" "}
                                                Short text
                                            </h4>
                                            <div className="button-list ms-auto d-flex">
                                                <Button variant="transparent">
                                                    <span className="material-symbols-outlined align-middle copy-btn me-2">
                                                        content_copy
                                                    </span>
                                                </Button>
                                                <Button variant="transparent">
                                                    <span className="material-symbols-outlined align-middle remove-btn">
                                                        delete
                                                    </span>
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="builder-row-body d-flex flex-wrap">
                                            <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                                                <Button variant="transparent">
                                                    <span className="material-symbols-outlined">
                                                        drag_indicator
                                                    </span>
                                                </Button>
                                            </div>
                                            <div className="builder-field p-3">
                                                <Form.Group className="mb-3" controlId="shorttext">
                                                    <Form.Label>
                                                        What is your name?
                                                        {/* <small className="d-block">This will help us ensure accurate communication and correspondence throughout the admission process.</small> */}
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search element"
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <div className="text-center">
                                        <Button variant="dark btn-lg">Button Name</Button>{" "}
                                        <Button variant="primary btn-lg">Button Name</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="formeditor-sidebar ms-auto bg-white global-tab h-100">
                        <div className="p-3 h-100 d-flex flex-column">
                            <div className="tab-content px-1">
                                <span className='text-sm font-medium grey-800'>General Setting</span>
                                <div className="mb-3 input-sm">
                                    <label for="LabelText" className="form-label">Label</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="LabelText"
                                        placeholder="Add Text"
                                    />
                                </div>
                                <div className="mb-3 input-sm">
                                    <label for="ID" className="form-label">ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="ID"
                                        placeholder="Unique ID"
                                    />
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="CalculateFiled"
                                        className="form-label"
                                    >
                                        Assign Role
                                    </label>
                                    <select
                                        className="form-select"
                                        id="CalculateFiled"
                                        aria-label="Default select example"
                                    >
                                        <option>Faculty</option>
                                        <option>Numeric calculation</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="CalculateFiled"
                                        className="form-label"
                                    >
                                        Form Field
                                    </label>
                                    <div className='p-2 border border-1 rounded-md bg-grey-50 d-flex flex-column align-items-start row-gap-3'>
                                        <ul className="mb-0 d-flex flex-wrap gap-1 list-unstyled max-h-200">
                                            <li>
                                                <span className="px-2 py-1 d-flex align-items-center gap-1 text-xs font-medium text-slate-600 border border-slate-200 rounded bg-white cursor-pointer serachby-tag ">Unique ID <i className='bx bx-x text-lg'></i></span>
                                            </li>
                                        </ul>
                                        <button type="button" className="btn btn-primary d-inline-flex align-items-center gap-1"><i className='bx bx-plus' ></i> Add Field</button>
                                    </div>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="CompletionRule"
                                        className="form-label"
                                    >
                                        Completion Rule
                                    </label>
                                    <select
                                        className="form-select"
                                        id="CompletionRule"
                                        aria-label="Default select example"
                                    >
                                        <option>Auto Completion</option>
                                        <option>Auto Completion 2</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label for="DueDate" className="form-label">Due Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="DueDate"
                                        placeholder="Unique ID"
                                    />
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="NextEvent"
                                        className="form-label"
                                    >
                                        Next Event
                                    </label>
                                    <select
                                        className="form-select"
                                        id="NextEvent"
                                        aria-label="Default select example"
                                    >
                                        <option>Label</option>
                                        <option>Label 2</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="Duration"
                                        className="form-label"
                                    >
                                        Duration
                                    </label>
                                    <select
                                        className="form-select"
                                        id="Duration"
                                        aria-label="Default select example"
                                    >
                                        <option>1 Day</option>
                                        <option>2 Days</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="Position"
                                        className="form-label"
                                    >
                                        Position
                                    </label>
                                    <select
                                        className="form-select"
                                        id="Position"
                                        aria-label="Default select example"
                                    >
                                        <option>X</option>
                                        <option>Y</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="TemplateID"
                                        className="form-label"
                                    >
                                        Template ID
                                    </label>
                                    <select
                                        className="form-select"
                                        id="TemplateID"
                                        aria-label="Default select example"
                                    >
                                        <option>SEND_MAIL</option>
                                        <option>SEND_MAIL 2</option>
                                    </select>
                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="CalculateFiled"
                                        className="form-label"
                                    >
                                        Trigger
                                    </label>

                                    <div className="d-flex flex-column gap-2">
                                        {/* Before Task */}
                                        <div className="d-flex flex-column gap-1">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="radioDefault"
                                                    id="Beforetask"
                                                    value="before"
                                                    checked={selectedOption === 'before'}
                                                    onChange={(e) => setSelectedOption(e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="Beforetask">
                                                    Before task
                                                </label>
                                            </div>
                                            {selectedOption === 'before' && (
                                                <select className="form-select" aria-label="Default select example">
                                                    <option>Select Task ID</option>
                                                    <option>Faculty</option>
                                                </select>
                                            )}
                                        </div>

                                        {/* After Task */}
                                        <div className="d-flex flex-column gap-1">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="radioDefault"
                                                    id="Aftertask"
                                                    value="after"
                                                    checked={selectedOption === 'after'}
                                                    onChange={(e) => setSelectedOption(e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="Aftertask">
                                                    After task
                                                </label>
                                            </div>
                                            {selectedOption === 'after' && (
                                                <select className="form-select" aria-label="Default select example">
                                                    <option>Select Task ID</option>
                                                    <option>Faculty</option>
                                                </select>
                                            )}
                                        </div>

                                        {/* On Condition */}
                                        <div className="d-flex flex-column gap-1">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="radioDefault"
                                                    id="OnCondition"
                                                    value="condition"
                                                    checked={selectedOption === 'condition'}
                                                    onChange={(e) => setSelectedOption(e.target.value)}
                                                />
                                                <label className="form-check-label" htmlFor="OnCondition">
                                                    On Condition
                                                </label>
                                            </div>
                                            {selectedOption === 'condition' && (
                                                <select className="form-select" aria-label="Default select example">
                                                    <option>Select Task ID</option>
                                                    <option>Faculty</option>
                                                </select>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                <div className="mb-3 input-sm">
                                    <label
                                        for="Status"
                                        className="form-label"
                                    >
                                        Status
                                    </label>
                                    <select
                                        className="form-select"
                                        id="Status"
                                        aria-label="Default select example"
                                    >
                                        <option>Accepted</option>
                                        <option>Pending</option>
                                    </select>
                                </div>
                            </div>


                            <div className="mt-3 d-grid gap-2">
                                <Button variant="dark">
                                    <i className="bx bx-save bx-sm align-middle"></i> Save Properties
                                </Button>
                                {/* <Button variant="gray-light">
										<i className="bx bx-globe bx-sm align-middle"></i> Save as
										Global Field
									</Button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Workflow